export const universalLink = 'https://flipfit.app.link/GSi4Su4P51'
